import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  cssVariables: true,
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#003c71',
          dark: '#002855',
          light: '#0056a3',
          contrastText: '#ffffff',
        },
        secondary: {
          main: '#ffc425',
          dark: '#e6a800',
          light: '#ffd04d',
          contrastText: '#003c71',
        },
        success: {
          main: '#4caf50',
          dark: '#388e3c',
          light: '#66bb6a',
        },
        error: {
          main: '#f44336',
        },
        background: {
          default: '#f5f5f5',
          paper: '#ffffff',
        },
        text: {
          primary: '#003c71',
          secondary: '#546e7a',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Sarabun', 'Inter', system-ui, sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '12px 32px',
          fontSize: '1.05rem',
          boxShadow: '0 4px 15px rgba(0, 60, 113, 0.15)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(0, 60, 113, 0.25)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(45deg, #003c71, #0056a3)',
          '&:hover': {
            background: 'linear-gradient(45deg, #002855, #003c71)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(45deg, #ffc425, #ffd04d)',
          color: '#003c71',
          fontWeight: 700,
          '&:hover': {
            background: 'linear-gradient(45deg, #e6a800, #ffc425)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          boxShadow: '0 20px 60px rgba(0, 60, 113, 0.15)',
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '&:hover fieldset': {
              borderColor: '#003c71',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#003c71',
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '2px solid #ffc425',
          boxShadow: '0 8px 24px rgba(0, 60, 113, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 32px rgba(0, 60, 113, 0.2)',
            borderColor: '#003c71',
          },
        },
      },
    },
  },
});

export default theme;
